import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 2000.000000 2000.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,2000.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M6478 12817 c-20 -12 -90 -60 -155 -106 -65 -47 -152 -109 -193 -138
-41 -29 -79 -56 -85 -61 -14 -11 -172 -124 -199 -142 -90 -61 -425 -297 -451
-318 -5 -4 -61 -44 -124 -88 -63 -43 -143 -99 -178 -124 -35 -25 -125 -89
-201 -142 -75 -53 -155 -112 -177 -131 l-40 -35 0 -597 0 -597 33 -29 c23 -21
42 -29 70 -29 41 0 63 12 136 77 127 113 387 287 516 345 14 6 52 24 85 39 84
38 314 116 415 141 341 81 700 89 1035 22 131 -26 151 -31 300 -80 152 -50
262 -98 415 -181 158 -87 370 -237 370 -264 0 -18 -185 -229 -201 -229 -4 0
-38 22 -74 50 -103 78 -201 140 -310 195 -140 71 -179 86 -430 165 -30 9 -160
34 -270 51 -123 18 -335 21 -465 5 -175 -22 -150 -17 -370 -66 -85 -19 -313
-111 -430 -173 -156 -84 -405 -266 -442 -325 -10 -15 -18 -46 -18 -70 0 -41 6
-49 152 -210 84 -92 187 -203 230 -246 l76 -79 43 7 c42 7 65 21 142 87 113
96 305 195 457 235 30 8 71 19 90 24 88 25 317 36 430 20 82 -12 256 -54 289
-70 9 -4 57 -26 106 -49 129 -61 235 -129 235 -150 0 -19 -227 -274 -239 -269
-3 2 -58 29 -121 60 -107 53 -153 68 -300 99 -59 12 -220 7 -305 -9 -142 -27
-309 -105 -412 -191 -64 -55 -71 -64 -75 -103 -6 -55 4 -82 39 -105 48 -32
101 -23 164 29 75 60 148 101 244 134 70 24 95 27 210 28 111 1 141 -3 205
-23 106 -34 187 -79 293 -163 19 -16 42 -23 71 -23 46 0 78 21 135 90 18 22
77 87 130 145 260 281 241 257 241 306 0 60 -7 71 -87 136 -159 129 -269 191
-463 263 -168 62 -307 85 -520 85 -230 0 -384 -29 -575 -105 -117 -47 -256
-125 -347 -195 -28 -21 -48 -26 -48 -11 0 10 -75 93 -172 191 -27 27 -48 52
-48 57 0 9 127 105 200 151 104 64 289 150 406 187 27 8 63 19 79 25 147 47
444 75 640 61 120 -9 299 -38 370 -61 249 -80 372 -136 538 -247 60 -40 144
-102 187 -138 83 -70 122 -85 169 -65 27 11 392 398 418 444 7 12 12 39 13 61
0 36 -6 45 -63 100 -164 157 -474 357 -692 447 -138 57 -196 78 -374 133 -168
52 -438 85 -691 85 -377 0 -656 -52 -1000 -183 -92 -35 -255 -114 -318 -154
-29 -18 -55 -33 -59 -33 -5 0 -150 -96 -219 -145 -7 -5 -15 -7 -18 -4 -4 4 -9
570 -6 750 0 31 6 40 38 62 97 65 395 276 417 295 6 4 42 30 80 57 39 26 191
134 339 239 147 105 305 217 350 248 44 32 97 69 116 83 19 14 56 40 81 58 26
17 90 63 143 100 l96 68 75 -53 c131 -92 250 -177 260 -185 6 -5 48 -35 95
-67 47 -33 110 -77 140 -98 259 -184 844 -600 959 -681 226 -160 237 -165 298
-127 22 13 36 32 44 60 21 71 3 92 -193 231 -95 67 -204 145 -243 173 -38 28
-77 56 -86 61 -10 6 -54 37 -100 70 -45 33 -105 76 -133 95 -97 68 -331 233
-356 252 -23 18 -368 260 -402 283 -9 6 -60 42 -114 81 -186 134 -204 144
-243 144 -20 0 -53 -10 -73 -23z"
          />
          <path d="M6240 12005 l0 -125 130 0 130 0 0 125 0 125 -130 0 -130 0 0 -125z" />
          <path
            d="M6592 12008 l3 -123 128 -3 127 -3 1 96 c1 52 1 107 2 123 l1 27
-132 3 -133 3 3 -123z"
          />
          <path d="M6242 11658 l3 -133 125 0 125 0 0 130 0 130 -128 3 -128 3 3 -133z" />
          <path
            d="M6594 11777 c-2 -7 -3 -67 -2 -133 l3 -119 119 -2 c66 -1 125 2 131
7 6 5 10 29 9 52 0 24 -2 80 -3 126 l-1 82 -125 0 c-94 0 -127 -3 -131 -13z"
          />
          <path
            d="M10603 11060 c-126 -25 -203 -125 -203 -262 l0 -58 -63 0 c-36 0 -68
-5 -75 -12 -16 -16 -16 -120 0 -136 7 -7 39 -12 75 -12 l64 0 -1 -301 c-1
-167 3 -306 8 -311 5 -5 44 -8 88 -6 l79 3 3 307 2 307 103 3 102 3 0 75 0 75
-104 3 -103 3 4 60 c3 43 10 66 25 80 28 29 95 42 145 29 22 -6 42 -10 43 -8
2 2 7 38 11 79 l6 76 -38 6 c-50 9 -118 7 -171 -3z"
          />
          <path
            d="M13298 11050 c-21 -5 -23 -12 -26 -86 -2 -61 1 -84 12 -93 9 -8 45
-11 103 -9 l88 3 5 76 c7 112 11 107 -80 111 -44 2 -90 1 -102 -2z"
          />
          <path
            d="M13707 11054 c-4 -4 -7 -247 -7 -539 0 -445 2 -534 14 -544 9 -8 43
-11 93 -9 l78 3 0 545 0 545 -85 3 c-47 1 -89 0 -93 -4z"
          />
          <path
            d="M8585 11038 c-3 -7 -4 -251 -3 -543 l3 -530 90 0 90 0 5 225 5 225
320 0 320 0 5 -225 5 -225 90 0 90 0 0 540 0 540 -88 3 c-64 2 -89 -1 -92 -10
-2 -7 -6 -110 -7 -228 l-3 -215 -320 0 -320 0 -2 218 c-1 119 -5 222 -8 227
-9 15 -175 13 -180 -2z"
          />
          <path
            d="M12120 10749 c-74 -7 -121 -25 -166 -62 -18 -15 -34 -27 -37 -27 -3
0 -7 17 -9 38 l-3 37 -73 3 c-46 2 -79 -2 -88 -9 -19 -16 -21 -738 -2 -757 16
-16 150 -16 166 0 9 9 12 77 12 245 0 267 5 290 82 340 36 24 52 28 114 28 82
0 114 -16 149 -76 18 -31 20 -57 25 -289 l5 -255 85 0 85 0 5 240 c3 132 10
249 14 260 34 78 106 124 194 125 81 0 137 -38 161 -109 7 -22 11 -119 11
-266 0 -188 3 -235 14 -244 9 -7 42 -11 88 -9 l73 3 3 259 c3 291 -3 332 -61
408 -64 84 -138 118 -259 119 -99 1 -173 -27 -236 -90 l-48 -48 -37 43 c-63
72 -154 104 -267 93z"
          />
          <path
            d="M11035 10736 c-134 -42 -210 -125 -222 -241 l-6 -53 81 -7 c44 -4 85
-4 90 -1 5 3 15 26 21 50 20 80 101 123 213 113 69 -6 113 -30 133 -74 20 -41
8 -67 -37 -82 -18 -6 -104 -22 -191 -36 -87 -14 -175 -32 -195 -41 -79 -33
-112 -87 -112 -184 0 -73 23 -125 77 -169 105 -86 322 -87 440 -2 23 16 44 27
47 24 3 -4 6 -21 6 -40 l0 -34 153 3 152 3 3 63 c2 35 -2 69 -7 76 -6 7 -32
11 -69 9 l-60 -2 -4 202 c-4 157 -9 212 -22 246 -34 91 -95 145 -196 175 -65
19 -237 20 -295 2z m325 -478 c0 -48 -3 -54 -43 -92 -48 -47 -100 -66 -178
-66 -64 0 -117 24 -138 61 -13 24 -13 29 3 53 9 15 28 31 42 36 20 8 260 54
302 59 8 1 12 -15 12 -51z"
          />
          <path
            d="M13132 10728 c-7 -7 -12 -37 -12 -68 0 -31 5 -61 12 -68 7 -7 42 -12
85 -12 l73 0 -2 -232 -3 -233 -80 -5 -80 -5 -3 -61 c-2 -43 1 -64 11 -73 11
-8 83 -11 258 -9 l244 3 3 73 c2 53 0 72 -10 73 -7 0 -43 0 -80 -1 l-68 -1 0
303 c0 223 -3 307 -12 316 -17 17 -319 17 -336 0z"
          />
          <path
            d="M13947 10733 c-16 -15 1 -67 132 -408 130 -336 141 -360 165 -363 14
-2 26 -8 26 -13 0 -5 -21 -61 -46 -124 -25 -63 -44 -122 -40 -130 4 -12 24
-15 93 -15 l88 0 199 512 c151 387 196 515 189 527 -8 13 -28 16 -92 16 l-83
0 -111 -297 c-62 -164 -115 -298 -118 -298 -4 0 -58 135 -120 300 l-114 300
-81 0 c-44 0 -84 -3 -87 -7z"
          />
          <path
            d="M9744 10467 c-3 -8 -4 -43 -2 -78 l3 -64 230 0 230 0 0 75 0 75 -228
3 c-186 2 -228 0 -233 -11z"
          />
          <path
            d="M8797 9554 c-4 -4 -7 -97 -7 -206 0 -109 -2 -198 -5 -198 -3 0 -25
16 -51 35 -64 49 -137 68 -244 63 -73 -3 -98 -9 -153 -36 -231 -114 -287 -451
-106 -647 57 -62 112 -93 199 -111 112 -23 224 0 306 62 24 19 46 34 49 34 2
0 5 -19 7 -42 l3 -43 76 -3 c56 -2 79 1 88 11 8 11 11 153 9 548 l-3 534 -80
3 c-45 1 -84 0 -88 -4z m-135 -486 c91 -50 141 -164 119 -269 -15 -69 -33
-101 -81 -142 -73 -62 -180 -73 -269 -28 -136 70 -163 289 -50 402 70 70 193
86 281 37z"
          />
          <path
            d="M13117 9554 c-4 -4 -7 -252 -7 -551 l0 -543 83 0 c93 0 107 7 107 57
l0 33 48 -34 c68 -49 133 -68 227 -68 117 0 182 27 266 111 87 87 112 148 113
281 1 114 -19 185 -73 256 -78 103 -180 154 -308 154 -86 0 -157 -20 -222 -64
l-51 -34 -2 201 -3 202 -85 3 c-47 1 -89 0 -93 -4z m529 -482 c81 -41 123
-118 124 -222 0 -193 -180 -307 -349 -221 -136 70 -163 289 -50 402 68 68 188
86 275 41z"
          />
          <path
            d="M10076 9414 c-3 -9 -6 -58 -6 -110 l0 -94 -70 0 -70 0 0 -55 0 -55
70 0 70 0 0 -194 c0 -106 5 -218 10 -247 21 -114 100 -179 226 -187 40 -2 89
-2 108 2 l36 7 0 54 0 54 -62 -5 c-72 -6 -117 12 -152 59 -19 26 -21 45 -24
243 l-4 214 116 0 116 0 0 55 0 54 -112 3 -113 3 -3 108 -3 107 -63 0 c-49 0
-65 -4 -70 -16z"
          />
          <path
            d="M9297 9239 c-130 -31 -222 -126 -234 -244 l-6 -53 81 -7 c44 -4 85
-4 90 -1 5 3 15 26 21 50 20 80 97 122 205 114 79 -7 124 -30 142 -74 29 -70
8 -81 -231 -120 -184 -29 -231 -47 -271 -99 -40 -53 -46 -153 -14 -220 26 -54
93 -107 160 -127 104 -30 266 -4 345 57 19 14 36 25 39 25 3 0 6 -18 6 -40 l0
-40 144 0 c112 0 146 3 155 14 7 9 11 38 9 73 l-3 58 -67 3 -68 3 0 162 c0
186 -10 263 -43 327 -30 57 -103 114 -177 134 -61 17 -219 20 -283 5z m313
-479 c0 -43 -5 -55 -35 -89 -82 -90 -279 -97 -325 -12 -14 28 -3 69 24 83 17
10 268 61 324 67 8 1 12 -15 12 -49z"
          />
          <path
            d="M10747 9239 c-130 -31 -222 -126 -234 -244 l-6 -53 81 -7 c44 -4 85
-4 90 -1 5 3 15 26 21 50 20 80 97 122 205 114 79 -7 124 -30 142 -74 29 -70
8 -81 -231 -120 -184 -29 -231 -47 -271 -99 -40 -53 -46 -153 -14 -220 26 -54
93 -107 160 -127 104 -30 266 -4 345 57 19 14 36 25 39 25 3 0 6 -18 6 -40 l0
-40 144 0 c112 0 146 3 155 14 7 9 11 38 9 73 l-3 58 -67 3 -68 3 0 162 c0
186 -10 263 -43 327 -30 57 -103 114 -177 134 -61 17 -219 20 -283 5z m313
-479 c0 -43 -5 -55 -35 -89 -82 -90 -279 -97 -325 -12 -14 28 -3 69 24 83 17
10 268 61 324 67 8 1 12 -15 12 -49z"
          />
          <path
            d="M11610 9236 c-149 -43 -229 -153 -201 -276 19 -85 98 -136 257 -165
211 -39 237 -45 261 -60 31 -21 38 -41 24 -71 -29 -64 -197 -86 -298 -39 -42
19 -56 32 -69 62 -9 21 -20 45 -24 53 -5 11 -28 16 -89 18 l-81 3 0 -44 c0
-63 42 -140 102 -188 124 -97 363 -114 518 -37 82 42 121 94 128 172 6 73 -11
118 -63 164 -53 47 -112 67 -270 92 -190 31 -215 42 -215 90 0 69 136 112 255
79 48 -14 103 -67 111 -108 5 -22 14 -33 31 -37 26 -7 142 2 152 11 3 3 0 31
-7 62 -20 96 -82 163 -192 208 -58 24 -263 31 -330 11z"
          />
          <path
            d="M12210 9225 c-9 -10 -11 -79 -8 -267 4 -230 6 -258 25 -306 33 -81
83 -136 160 -174 60 -29 74 -32 152 -31 97 0 156 18 213 63 20 17 39 30 42 30
3 0 6 -17 8 -37 l3 -38 85 0 85 0 3 374 c2 267 -1 378 -9 387 -15 18 -140 19
-157 2 -9 -9 -12 -75 -12 -235 0 -239 -5 -270 -53 -321 -51 -55 -149 -83 -223
-63 -54 14 -90 43 -114 92 -18 35 -20 59 -20 277 0 172 -3 241 -12 250 -18 18
-152 16 -168 -3z"
          />
          <path
            d="M6460 8931 c-59 -13 -103 -37 -142 -76 -59 -59 -73 -98 -73 -195 0
-83 2 -87 40 -145 58 -87 121 -120 230 -119 74 0 85 3 141 37 50 29 66 47 91
94 42 78 49 134 28 211 -38 136 -180 223 -315 193z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
